import { IOption, Categories, OptionType } from "../../../models/IOption";

export const SandboxType: IOption[] = [
  {
    Key: "stu",
    Description: "Student",
    Category: Categories.Type,
    Selected: false,
    Type: OptionType.Radio,
  },
  {
    Key: "fin",
    Description: "Finance",
    Category: Categories.Type,
    Selected: false,
    Type: OptionType.Radio,
  },
];

export const DatabaseTypes: IOption[] = [
  {
    Key: "qDb",
    Description: "Qmlativ Database",
    Category: Categories.Database,
    Selected: false,
    Type: OptionType.Checkbox,
  },
  {
    Key: "smsDb",
    Description: "SMS 2.0 Database",
    Category: Categories.Database,
    Selected: false,
    Type: OptionType.Checkbox,
  },
];

export const SandboxDurationPricing: IOption[] = [
  {
    Key: "AddNinetyDays",
    Description: "Additional 90 Days",
    Category: Categories.Duration,
    Price: 200,
    Selected: false,
    Type: OptionType.Checkbox,
  },
  {
    Key: "OneYear",
    Description: "1 year from signing of contract",
    Category: Categories.Duration,
    Price: 595,
    Selected: false,
    Type: OptionType.Checkbox,
  },
];

export const FullSandboxPricing: IOption[] = [
  {
    Key: "stuFull",
    Description: "Student Database",
    Category: Categories.Usage,
    Selected: false,
    Type: OptionType.Radio,
  },
  {
    Key: "bizDB",
    Description: "Business Database",
    Category: Categories.Usage,
    Selected: false,
    Type: OptionType.Radio,
  },
];

export const DurationOptions: IOption[] = [
  {
    Key: "isOriginal",
    Description: "Standard (180 Days)",
    Category: Categories.Duration,
    Selected: true,
    Type: OptionType.Radio,
    Price: 995,
  },
  {
    Key: "isRenewal",
    Description: "Extended (365 Days)",
    Category: Categories.Duration,
    Selected: false,
    Type: OptionType.Radio,
    Price: 1495,
  },
];

export const OneRosterDurationOption = {
  Key: "oneRosterDuration",
  Description: "Standard (365 Days)",
  Category: Categories.Duration,
  Selected: true,
  Type: OptionType.Radio,
  Price: 495,
};

export const ExtraSandboxAccess: IOption[] = [
  {
    Key: "UI",
    Description: "UI Access",
    Category: Categories.Extras,
    Selected: false,
    Type: OptionType.Checkbox,
  },
  {
    Key: "SSO",
    Description: "SSO Access",
    Category: Categories.Extras,
    Selected: false,
    Type: OptionType.Checkbox,
  },
  {
    Key: "DB",
    Description: "Direct DB (ODBC) Access",
    Category: Categories.Extras,
    Selected: false,
    Type: OptionType.Checkbox,
  },
];
